const changeLayoutName = (canvasState, command) => canvasState.set(
    'layoutName',
    command.get('name')
);

export default changeLayoutName;
